export enum FilterKeys {
  SALARY_RANGE = 'salary_range',
  SENIORITY = 'seniority',
  SPECIALITY = 'speciality',
}
